<template>
    <div class="Case" id="a5">
        <div class="Case-title"> {{Title}} </div>
        <div class="Case-subheading"> {{Subheading}} </div>
        <div class="Case-content-bg">
            <div class="Case-content-bg-item" v-for="(logo, index) in Logos" :key="index">
                <img class="Case-content-bg-item-img" :src=logo>
            </div>
        </div>
        <div style="width: 200px; margin: 0 auto;">
            <div class="Case-button" @mousemove="disabled=true" @mouseleave="disabled=false"> 获取案例 </div>
            <div class="Case-tooltip" v-if="disabled">
                <img class="Case-QRCode" :src=QRCode>
                <div class="Case-QRCode-title"> 关注“宝来客”学习运营秘籍 </div>
            </div>
        </div>
        
    </div>
</template>

<script>

export default {
    data() {
        return {
            disabled:false,
            Title: "部分客户案例",
            Subheading: "企业以及众多零售商家的共同选择",
            QRCode: require("../assets/img/home/QRCode.png"),
            Logos: [
                require("../assets/img/home/logo0.png"),
                require("../assets/img/home/logo1.png"),
                require("../assets/img/home/logo2.png"),
                require("../assets/img/home/logo3.png"),
                require("../assets/img/home/logo4.png"),
                require("../assets/img/home/logo5.png"),
                require("../assets/img/home/logo6.png"),
                require("../assets/img/home/logo7.png"),
                require("../assets/img/home/logo8.png"),
                require("../assets/img/home/logo9.png"),
                require("../assets/img/home/logo10.png"),
                require("../assets/img/home/logo11.png"),
            ],
        }
    },

    methods:{
        onGetCase() {

        }
    }
}
</script>

<style lang="scss" scoped>

.Case {
    
    width: 100%;
    background-color: #F0F1F7;
    margin: auto;
    padding-bottom: 100px;
    &-title {
        color: #211C39;
        padding-top: 100px;
        font-size: 34px;
        text-align: center;
        font-weight: 800;
    }
    &-subheading {
        color: #514D66;
        font-size: 20px;
        text-align: center;
        padding: 20px 0px 60px 0px;
    }
    &-content-bg {
        width: 1425px;
        padding-bottom: 20px;
        margin: auto;
        display: flex;
        flex-wrap:wrap;
        justify-content: center;
        &-item:nth-child(4n+1) {
            margin-left: 0;
        }
        &-item:nth-child(4n) {
            margin-right: 0;
        }
        &-item {
            width: 332px;
            height: 121px;
            background: #FFFFFF;
            border-radius: 10px;
            text-align: center;
            margin: 12px 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            &-img {
                max-width: 332px;
                max-height: 121px;
            }
        }
    }
    &-button {
        width: 200px;
        height: 70px;
        text-align: center;
        
        background: #7E49FE;
        line-height: 70px;
        box-shadow: 0px 10px 10px -3px rgba(126, 73, 254, 0.3);
        border-radius: 8px;
        display: block;
        margin:0 auto;
        font-size: 24px;
        font-weight: 800;
        color: #fff;
    }
    &-button:hover{
        background: rgba(126, 73, 254, 0.3);
    }
    &-tooltip {
        background-image: url("../assets/img/home/tooltip-bg.png");
        background-repeat: round;
        width: 334px;
        height: 320px;
        float: left;
        margin: -260px 0px 0px 190px;
        position: absolute;
        z-index: 999;
    }
    &-QRCode {
        width: 154px;
        height: 157px;
        margin-left: 105px;
        margin-top: 54px;
        &-title {
            width: 200px;
            font-size: 14px;
            font-weight: bold;
            color: #514D66;
            line-height: 14px;
            margin:0 auto;
            margin-left: 96px;
            padding: 10px 0px;
        }
    }
}

</style>